import { FaTelegramPlane, FaWhatsapp, FaLinkedin, FaGithub } from "react-icons/fa";
import { IoIosMail } from "react-icons/io";

export const SOCIALDATA = [
  {
    key: 1,
    icon: <FaLinkedin fontSize={20} />,
    link: "https://www.linkedin.com/in/ali-el-shoraa/",
  },
  {
    key: 2,
    icon: <FaGithub fontSize={20} />,
    link: "https://github.com/Ali-El-Shoraa",
  },
  {
    key: 3,
    icon: <FaWhatsapp fontSize={20} />,
    link: "https://wa.me/201550859246",
  },
  {
    key: 4,
    icon: <FaTelegramPlane fontSize={20} />,
    link: "https://t.me/Ali_El_Shoraa",
  },
  {
    key: 5,
    icon: <IoIosMail fontSize={20} />,
    link: "mailto:ali,m.elshoraa@gmail.com",
  },
];
